export default [
  {
    path: '/account',
    component: () => import('@/views/account/index.vue')
  }
]
